// extracted by mini-css-extract-plugin
module.exports = {"floating-cart":"FloatingCartIcon_floating-cart___dPnr","cart-count":"FloatingCartIcon_cart-count__OkrJ6"};